/**
 * API layer yêu thích — CRUD danh sách tin đã lưu của user.
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

/** Các hàm gọi API yêu thích. */
export const favoriteApi = {
  /** Danh sách BĐS yêu thích. */
  getFavorites: () => apiClient.get(API_ROUTES.favorites),
  /** Thêm tin vào yêu thích. */
  addFavorite: (propertyId) => apiClient.post(API_ROUTES.favoriteDetails(propertyId)),
  /** Cập nhật ghi chú trên tin yêu thích. */
  updateFavoriteNote: (propertyId, note) =>
    apiClient.patch(API_ROUTES.favoriteDetails(propertyId), { note }),
  /** Xóa khỏi yêu thích. */
  removeFavorite: (propertyId) => apiClient.delete(API_ROUTES.favoriteDetails(propertyId)),
};
